import styled from 'styled-components';

export const StyledForm = styled.form(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  height: '100%',
  width: '100%',
}));
